// As rotas são exportadas como array puro; o vite-ssg cria o router
// (createWebHistory no cliente, createMemoryHistory na build SSG).
export const routes = [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/Home.vue"),
    },
    {
      path: "/sobre-nos",
      name: "about",
      component: () => import("@/views/About.vue"),
    },
    {
      path: "/solucao/kali-gestao",
      name: "kali-gestao",
      component: () => import("@/views/SolutionKaliGestao.vue"),
    },
    {
      path: "/solucao/kali-agro",
      name: "kali-agro",
      component: () => import("@/views/SolutionKaliAgro.vue"),
    },
    {
      path: "/solucao/kali-food",
      name: "kali-food",
      component: () => import("@/views/SolutionKaliFood.vue"),
    },
    {
      path: "/solucao/kali-clinica",
      name: "kali-clinica",
      component: () => import("@/views/SolutionKaliClinica.vue"),
    },
    {
      path: "/solucao/kali-studio",
      name: "kali-studio",
      component: () => import("@/views/SolutionKaliStudio.vue"),
    },
    {
      path: "/solucao/kali-salao",
      name: "kali-salao",
      component: () => import("@/views/SolutionKaliSalao.vue"),
    },
    {
      path: "/solucao/kali-pet",
      name: "kali-pet",
      component: () => import("@/views/SolutionKaliPet.vue"),
    },
    {
      path: "/solucao/kali-shop",
      name: "kali-shop",
      component: () => import("@/views/SolutionKaliShop.vue"),
    },
    {
      path: "/segmentos",
      name: "segments",
      component: () => import("@/views/Segments.vue"),
    },
    {
      path: "/segmento/moda",
      name: "moda",
      component: () => import("@/views/SegmentModa.vue"),
    },
    {
      path: "/segmento/material-de-construcao",
      name: "material-de-construcao",
      component: () => import("@/views/SegmentMaterialConstrucao.vue"),
    },
    {
      path: "/segmento/mercados",
      name: "mercados",
      component: () => import("@/views/SegmentMercados.vue"),
    },
    {
      path: "/segmento/acougues",
      name: "acougues",
      component: () => import("@/views/SegmentAcougues.vue"),
    },
    {
      path: "/segmento/padarias",
      name: "padarias",
      component: () => import("@/views/SegmentPadarias.vue"),
    },
    {
      path: "/segmento/cosmeticos",
      name: "cosmeticos",
      component: () => import("@/views/SegmentCosmeticos.vue"),
    },
    {
      path: "/segmento/autopecas",
      name: "autopecas",
      component: () => import("@/views/SegmentAutopecas.vue"),
    },
    {
      path: "/segmento/bijuterias",
      name: "bijuterias",
      component: () => import("@/views/SegmentBijuterias.vue"),
    },
    {
      path: "/segmento/sorveterias",
      name: "sorveterias",
      component: () => import("@/views/SegmentSorveterias.vue"),
    },
    {
      path: "/clientes",
      name: "clients",
      component: () => import("@/views/Clients.vue"),
    },
    {
      path: "/parceiros",
      alias: "/parceria",
      name: "partnership",
      component: () => import("@/views/Partnership.vue"),
    },
    {
      path: "/blog",
      name: "blog",
      component: () => import("@/views/Blog.vue"),
    },
    {
      path: "/blog/:slug",
      name: "blog-detail",
      component: () => import("@/views/BlogPost.vue"),
      props: true,
    },
    {
      path: "/contato",
      name: "contact",
      component: () => import("@/views/Contact.vue"),
    },
    {
      path: "/carreiras",
      alias: "/trabalhe-conosco",
      name: "careers",
      component: () => import("@/views/Careers.vue"),
    },
    {
      path: "/suporte",
      name: "support",
      component: () => import("@/views/Support.vue"),
    },
    {
      path: "/status",
      name: "status",
      component: () => import("@/views/Status.vue"),
    },
    {
      path: "/politica-de-privacidade",
      name: "privacy",
      component: () => import("@/views/PrivacyPolicy.vue"),
    },
    {
      path: "/politica-de-cookies",
      name: "cookies",
      component: () => import("@/views/CookiePolicy.vue"),
    },
    {
      path: "/termos-de-uso",
      name: "terms",
      component: () => import("@/views/TermsOfUse.vue"),
    },
    {
      path: "/meus-dados",
      name: "data-rights",
      component: () => import("@/views/DataRightsRequest.vue"),
    },
    {
      path: "/certificado-digital",
      name: "certificado-digital",
      component: () => import("@/views/CertificadoDigital.vue"),
    },
    {
      path: "/boletos",
      name: "boletos",
      component: () => import("@/views/Boletos.vue"),
    },
    {
      path: "/whatsapp",
      name: "module-whatsapp",
      component: () => import("@/views/Whatsapp.vue"),
    },
    {
      path: "/assinador-digital",
      name: "module-assinador-digital",
      component: () => import("@/views/AssinadorDigital.vue"),
    },
    {
      path: "/lote",
      name: "module-lote",
      component: () => import("@/views/Lote.vue"),
    },
    {
      path: "/contrato",
      name: "module-contrato",
      component: () => import("@/views/Contrato.vue"),
    },
    {
      path: "/pix",
      name: "module-pix",
      component: () => import("@/views/Pix.vue"),
    },
    {
      path: "/promocao",
      name: "module-promocao",
      component: () => import("@/views/Promocao.vue"),
    },
    {
      path: "/:pathMatch(.*)*",
      name: "not-found",
      component: () => import("@/views/NotFound.vue"),
    },
];

export function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  }

  if (to.hash) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          el: to.hash,
          behavior: "smooth",
          top: 80, // Ajuste para compensar a navbar fixa
        });
      }, 500); // Pequeno delay para garantir que o conteúdo foi carregado
    });
  }

  return { top: 0 };
}
